import { SvgIcon } from '@material-ui/core';
import { FC } from 'react';

import { withStyles, WithStyles } from '@core/theme/utils/with-styles';

import { styles } from './Settings4.styles';

export interface Settings4IconProps extends WithStyles<typeof styles> {
  color?: string;
}

const Settings4IconComponent: FC<Settings4IconProps> = ({ classes, color = '#7E8899' }) => {
  return (
    <SvgIcon
      classes={{ root: classes.root }}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M2 5.33334L10 5.33334M10 5.33334C10 6.43791 10.8954 7.33334 12 7.33334C13.1046 7.33334 14 6.43791 14 5.33334C14 4.22877 13.1046 3.33334 12 3.33334C10.8954 3.33334 10 4.22877 10 5.33334ZM6 10.6667L14 10.6667M6 10.6667C6 11.7712 5.10457 12.6667 4 12.6667C2.89543 12.6667 2 11.7712 2 10.6667C2 9.56211 2.89543 8.66668 4 8.66668C5.10457 8.66668 6 9.56211 6 10.6667Z"
        stroke={color}
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};
export const Settings4Icon = withStyles(styles)(Settings4IconComponent);
